/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KomunikatPublicznyTo } from '../../models/komunikat-publiczny-to';

export interface ApiWebFaqGet$Params {

/**
 * Liczba wyników w odpowiedzi
 */
  ilosc?: number;

/**
 * Kod kategorii, właściwość kod z wywołania kategorie, pomiń parametr aby nie filtrować po kategoriach.
 */
  kategoria?: string;

/**
 * Pierwszy wiersz wyniku
 */
  od?: number;

/**
 * Sortowanie po czym, domyślnie dataPublikacji, możliwe dataModyfikacji
 */
  orderByColumn?: string;

/**
 * Sortowanie, domyślnie najpierw najnowsze, `asc' najpierw najstarsze
 */
  orderByDirection?: string;
}

export function apiWebFaqGet(http: HttpClient, rootUrl: string, params?: ApiWebFaqGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KomunikatPublicznyTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebFaqGet.PATH, 'get');
  if (params) {
    rb.query('ilosc', params.ilosc, {});
    rb.query('kategoria', params.kategoria, {});
    rb.query('od', params.od, {});
    rb.query('orderByColumn', params.orderByColumn, {});
    rb.query('orderByDirection', params.orderByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KomunikatPublicznyTo>>;
    })
  );
}

apiWebFaqGet.PATH = '/api/web/faq';
